module.exports = "img/user-onboarding/CommunityMessaging.0e6a083.png";